import React from "react";
import { Field } from "react-final-form";

export default function PublisheeRadio({ input, options, meta, className }) {
    const error = meta && meta.touched && meta.error;

    return (
        <Field name={input.name} className={`Field ${error ? "has-error" : ""} ${className}`}>
            {(props) => {
                const { value = [], onChange } = props.input;
                return (
                    <div className="Field u-mt-0">
                        <div className="Radio_group Radio_group--inline u-mt-0">
                            {options.map((option) => {
                                return (
                                    <RadioButtonOption key={option.value} value={option.value} checked={value === option.value} onChange={onChange}>
                                        {option.text}
                                        {option.uom && <>&nbsp;({option.uom})</>}
                                    </RadioButtonOption>
                                );
                            })}
                        </div>
                    </div>
                );
            }}
        </Field>
    );
}

function RadioButtonOption({ name, value, checked, children, onChange }) {
    const id = `${name}_${value}`;
    return (
        <label className="Radio" htmlFor={id}>
            <input type="radio" id={id} name={name} value={value} checked={checked} data-test-id={id} onChange={(e) => onChange(e.target.value)} className="Radio-input" />
            <span className="Radio-label">{children}</span>
        </label>
    );
}
